import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import s from './CircularProgress.module.scss';
const SIZE = 48;
const RADIUS = 22;
const STROKE_WIDTH = 4;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const CENTER = SIZE / 2;
export const CircularProgress = (param)=>{
    let { percent, testId } = param;
    const clamped = Math.max(0, Math.min(100, percent));
    const dashOffset = CIRCUMFERENCE * (1 - clamped / 100);
    return /*#__PURE__*/ _jsxs("svg", {
        width: SIZE,
        height: SIZE,
        viewBox: "0 0 ".concat(SIZE, " ").concat(SIZE),
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: CENTER,
                cy: CENTER,
                r: RADIUS,
                strokeWidth: STROKE_WIDTH,
                className: s.track
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: CENTER,
                cy: CENTER,
                r: RADIUS,
                strokeWidth: STROKE_WIDTH,
                strokeLinecap: "round",
                strokeDasharray: CIRCUMFERENCE,
                strokeDashoffset: dashOffset,
                transform: "rotate(-90 ".concat(CENTER, " ").concat(CENTER, ")"),
                className: s.arc
            })
        ]
    });
};
